var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"mt-1",attrs:{"block":"","text":"","disabled":!_vm.Ok,"loading":_vm.Cargando},on:{"click":_vm.Ejecutar}},[_vm._v("Etiquetas envío")])
}
var staticRenderFns = []

export { render, staticRenderFns }